import React, { useEffect, useState } from "react";
import NotLoggedInBanner from "./NotLoggedInBanner";
import LoginResetPopup from "../../Auth/Popups/LoginResetPopup";

const GameIframeNotLogged = () => {
  const [scrolledToTop, setScrolledToTop] = useState(false);
  useEffect(() => {
    if (!scrolledToTop) {
      window.scrollTo(0, 0);
      setScrolledToTop(true);
    }
  });

  return (
    <div className="not-logged-in button-banner-block">
      <div className="not-logged-in-hover button-banner-hover">
        <LoginResetPopup buttonText={"เล่นเลย"} buttonClass={"freespin-login-game-page-banner login-button"}/>
      </div>
      <NotLoggedInBanner/>
    </div>
  );
};

export default GameIframeNotLogged;

